module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "overflow-y": "auto"
    }
  }, [_c('pkHeader', {
    attrs: {
      "headerTitle": _vm.title,
      "backmethod": _vm.goback,
      "rightContentPropsMain": false
    }
  }), _vm._v(" "), _c('div', [_c('tab', {
    attrs: {
      "line-width": 2,
      "active-color": "#0d87e4",
      "custom-bar-width": "20",
      "animate": true
    },
    model: {
      value: (_vm.tabIndex),
      callback: function($$v) {
        _vm.tabIndex = $$v
      },
      expression: "tabIndex"
    }
  }, _vm._l((_vm.list), function(item, index) {
    return _c('tab-item', {
      key: index,
      staticClass: "vux-center",
      staticStyle: {
        "font-weight": "800",
        "font-size": ".85rem"
      },
      attrs: {
        "selected": _vm.defaultIndex === item
      },
      on: {
        "on-item-click": function($event) {
          _vm.selectTab(item)
        }
      }
    }, [_vm._v(_vm._s(item) + "\n            ")])
  })), _vm._v(" "), _c('group', {
    staticClass: "no_borderBottom",
    staticStyle: {
      "border-top": "0",
      "margin-top": "10px"
    },
    attrs: {
      "label-width": "2.5rem",
      "label-margin-right": "2em",
      "label-align": "right",
      "gutter": "0"
    }
  }, [(_vm.tabIndex == 1) ? _c('cell', {
    staticClass: "cell-height",
    attrs: {
      "value-align": "left"
    }
  }, [_c('div', {
    staticClass: "cell-fontSize Aircraft",
    attrs: {
      "slot": "value"
    },
    slot: "value"
  }, [_c('flexbox', [_c('flexbox-item', [_c('x-input', {
    attrs: {
      "type": "text",
      "placeholder": "起飞城市",
      "text-align": "center",
      "show-clear": false
    },
    on: {
      "on-focus": function($event) {
        _vm.linkto('start')
      }
    },
    model: {
      value: (_vm.start),
      callback: function($$v) {
        _vm.start = $$v
      },
      expression: "start"
    }
  })], 1), _vm._v(" "), _c('flexbox-item', [_c('x-input', {
    attrs: {
      "type": "text",
      "placeholder": "到达城市",
      "text-align": "center",
      "show-clear": false
    },
    on: {
      "on-focus": function($event) {
        _vm.linkto('end')
      }
    },
    model: {
      value: (_vm.end),
      callback: function($$v) {
        _vm.end = $$v
      },
      expression: "end"
    }
  })], 1)], 1), _vm._v(" "), _c('img', {
    staticClass: "singer",
    attrs: {
      "src": require("../../assets/img/singer.png"),
      "alt": ""
    },
    on: {
      "click": _vm.changeCity
    }
  })], 1)]) : _vm._e(), _vm._v(" "), (_vm.tabIndex == 0) ? _c('cell', {
    staticClass: "cell-height",
    attrs: {
      "value-align": "left"
    }
  }, [_c('img', {
    staticClass: "cell-lable-right",
    attrs: {
      "slot": "icon",
      "width": "22",
      "src": require("../../assets/img/fir.png")
    },
    slot: "icon"
  }), _vm._v(" "), _c('div', {
    staticClass: "cell-fontSize",
    staticStyle: {
      "margin-left": "-1rem"
    },
    attrs: {
      "slot": "value"
    },
    slot: "value"
  }, [_c('x-input', {
    attrs: {
      "type": "text",
      "placeholder": "请输入航班号",
      "max": 10
    },
    model: {
      value: (_vm.airNo),
      callback: function($$v) {
        _vm.airNo = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "airNo"
    }
  })], 1)]) : _vm._e(), _vm._v(" "), _c('cell', {
    staticClass: "cell-height",
    attrs: {
      "value-align": "left"
    }
  }, [_c('img', {
    staticClass: "cell-lable-right",
    attrs: {
      "slot": "icon",
      "width": "22",
      "src": require("../../assets/img/data.png")
    },
    slot: "icon"
  }), _vm._v(" "), _c('div', {
    staticClass: "cell-fontSize",
    attrs: {
      "slot": "value"
    },
    on: {
      "click": _vm.chooseDate
    },
    slot: "value"
  }, [_c('span', {}, [_vm._v(_vm._s(_vm.formateDate(_vm.quirydate)))])])])], 1), _vm._v(" "), _c('box', {
    attrs: {
      "gap": "10px 10px"
    }
  }, [_c('x-button', {
    attrs: {
      "type": "primary"
    },
    nativeOn: {
      "click": function($event) {
        _vm.serach()
      }
    }
  }, [_vm._v("查询")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-516d9e98"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pickGiveAircraft/serachAircraft.vue
// module id = 402
// module chunks = 1